module.exports = __webpack_public_path__ + "img/chl.82b580c0.svg";